import util from './util'

let Lexicon = Vue.component('lexicon', {
	data() {
		return {
			lexiconItems: []
		}
	},
	mounted() {
		util.getLexicon().then((response) => {
			console.log(response)
			this.lexiconItems = response
		}).catch((e) => {
			console.log('e')
		})
	},
	template: `
		<transition-group name="fade" tag="ul" class="medium-list">
			<li v-for="item in lexiconItems" :key="item.id">
				<colored-link type="lexicon" :data-id="item.id" :href="item.link">{{ item.name }}</colored-link>
			</li>
		</transition-group>`
})

export default Lexicon
